"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("@material-ui/core/styles");
var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _Hidden = _interopRequireDefault(require("@material-ui/core/Hidden"));
var _reactWindow = require("react-window");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      margin: 'auto'
    },
    paper: {
      width: '100%',
      height: function height(props) {
        return props.height;
      },
      overflow: 'auto'
    },
    button: {
      margin: theme.spacing(0.5, 0.5)
    },
    rootPaperLeft: {
      paddingLeft: '0px !important'
    },
    rootPaperRight: {
      paddingRight: '8px !important'
    },
    label: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1)
    },
    listItemText: {
      '& span': {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }
    },
    gridEmpty: {
      width: '100%',
      marginTop: theme.spacing(1),
      overflow: 'hidden'
    }
  };
});
function not(a, b, getItemIdentifier) {
  return a.filter(function (value) {
    return !b.find(function (vb) {
      var getId = getItemIdentifier || function (item) {
        return item.id;
      };
      return getId(vb) === getId(value);
    });
  });
}
function applyFilterLeft(allItens, selectedItens, getItemIdentifier) {
  return not(allItens, selectedItens, getItemIdentifier);
}
var Row = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var data = _ref.data,
    index = _ref.index,
    style = _ref.style;
  var classes = useStyles();
  var items = data.items,
    getItemIdentifier = data.getItemIdentifier,
    getItemText = data.getItemText,
    setChecked = data.setChecked;
  var item = items[index];
  if (!item) {
    return null;
  }
  item.checked = !!item.checked;
  var labelId = "transfer-list-item-".concat(getItemIdentifier(item), "-label");
  var handleToggle = function handleToggle(e) {
    item.checked = !item.checked;
    setChecked(function (c) {
      return item.checked ? ++c : --c;
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], {
    key: index,
    button: true,
    onClick: handleToggle,
    style: style,
    disableRipple: true,
    disabled: item.disabled
  }, /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], null, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    size: 'small',
    checked: item.checked,
    tabIndex: -1,
    disableRipple: true,
    inputProps: {
      'aria-labelledby': labelId
    }
  })), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    size: 'small',
    id: labelId,
    primary: getItemText(item),
    className: classes.listItemText
  }));
}, _reactWindow.areEqual);
var SttDoubleList = function SttDoubleList(_ref2) {
  var allItens = _ref2.allItens,
    selectedItens = _ref2.selectedItens,
    onChange = _ref2.onChange,
    getItemText = _ref2.getItemText,
    getItemIdentifier = _ref2.getItemIdentifier,
    labelLeft = _ref2.labelLeft,
    labelRight = _ref2.labelRight,
    reset = _ref2.reset,
    callbackReset = _ref2.callbackReset,
    _ref2$height = _ref2.height,
    height = _ref2$height === void 0 ? 500 : _ref2$height;
  var classes = useStyles({
    height: height
  });
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    checkedLeft = _useState2[0],
    setCheckedLeft = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    checkedRight = _useState4[0],
    setCheckedRight = _useState4[1];
  var _useState5 = (0, _react.useState)(applyFilterLeft(allItens, selectedItens, getItemIdentifier)),
    _useState6 = _slicedToArray(_useState5, 2),
    left = _useState6[0],
    setLeft = _useState6[1];
  var _useState7 = (0, _react.useState)(selectedItens),
    _useState8 = _slicedToArray(_useState7, 2),
    right = _useState8[0],
    setRight = _useState8[1];
  var sortList = function sortList(a, b) {
    var normalizeText = function normalizeText(text) {
      return text.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    };
    var nameA = normalizeText(getItemText(a));
    var nameB = normalizeText(getItemText(b));
    return nameA.localeCompare(nameB);
  };
  var handleAllRight = function handleAllRight() {
    var disabled = left.filter(function (l) {
      return l.disabled;
    });
    var notDisabled = left.filter(function (l) {
      return !l.disabled;
    });
    var newRight = right.concat(notDisabled);
    newRight.forEach(function (el) {
      el.checked = false;
    });
    setRight(newRight.sort(sortList));
    setLeft(disabled);
    setCheckedRight(0);
    setCheckedLeft(0);
  };
  var handleCheckedRight = function handleCheckedRight() {
    var selected = left.filter(function (l) {
      return l.checked;
    });
    var notSelected = left.filter(function (l) {
      return !l.checked;
    });
    var newRight = right.concat(selected);
    newRight.forEach(function (el) {
      el.checked = false;
    });
    setRight(newRight.sort(sortList));
    setLeft(notSelected);
    setCheckedRight(0);
    setCheckedLeft(0);
  };
  var handleCheckedLeft = function handleCheckedLeft() {
    var selected = right.filter(function (l) {
      return l.checked;
    });
    var notSelected = right.filter(function (l) {
      return !l.checked;
    });
    var newLeft = left.concat(selected);
    newLeft.forEach(function (el) {
      el.checked = false;
    });
    setLeft(newLeft.sort(sortList));
    setRight(notSelected);
    setCheckedRight(0);
    setCheckedLeft(0);
  };
  var handleAllLeft = function handleAllLeft() {
    var disabled = right.filter(function (r) {
      return r.disabled;
    });
    var notDisabled = right.filter(function (r) {
      return !r.disabled;
    });
    var newLeft = left.concat(notDisabled);
    newLeft.forEach(function (el) {
      el.checked = false;
    });
    setLeft(newLeft.sort(sortList));
    setRight(disabled);
    setCheckedRight(0);
    setCheckedLeft(0);
  };
  (0, _react.useEffect)(function () {
    setLeft(applyFilterLeft(allItens, selectedItens, getItemIdentifier));
    setRight(selectedItens);
  }, [allItens, selectedItens]);
  (0, _react.useEffect)(function () {
    if (reset) {
      setCheckedRight(0);
      setCheckedLeft(0);
      var newRight = selectedItens;
      newRight.forEach(function (el) {
        el.checked = false;
      });
      var newLeft = applyFilterLeft(allItens, selectedItens, getItemIdentifier);
      newLeft.forEach(function (el) {
        el.checked = false;
      });
      setRight(selectedItens);
      setLeft(newLeft);
      callbackReset && callbackReset();
    }
  }, [reset]);
  (0, _react.useEffect)(function () {
    onChange && onChange(right);
  }, [right]);
  var createItemData = function createItemData(items, setChecked) {
    return {
      items: items,
      getItemIdentifier: getItemIdentifier,
      getItemText: getItemText,
      classes: classes,
      setChecked: setChecked
    };
  };
  var customList = function customList(items, setChecked, textoSemItem) {
    var itemData = createItemData(items, setChecked);
    return /*#__PURE__*/_react["default"].createElement(_Paper["default"], {
      className: classes.paper
    }, items.length > 0 ? /*#__PURE__*/_react["default"].createElement(_reactWindow.FixedSizeList, {
      height: height,
      itemCount: items.length,
      itemData: itemData,
      itemSize: 35,
      width: "100%"
    }, Row) : /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
      container: true,
      spacing: 1,
      alignItems: "center",
      justifyContent: "center",
      className: classes.gridEmpty
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      component: "legend",
      className: classes.label
    }, textoSemItem)));
  };
  return /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    spacing: 1,
    alignItems: "center",
    className: classes.root
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 12,
    md: true,
    className: classes.rootPaperLeft
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    component: "legend",
    className: classes.label
  }, labelLeft), customList(left, setCheckedLeft, 'Nenhum item disponível')), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 12,
    md: 1
  }, /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    smDown: true
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: "column",
    alignItems: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleAllRight,
    disabled: left.length === 0,
    "aria-label": "Mover tudo para \xE0 direita"
  }, "\u226B"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleCheckedRight,
    disabled: checkedLeft === 0,
    "aria-label": "Mover selecionados para \xE0 direita"
  }, ">"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleCheckedLeft,
    disabled: checkedRight === 0,
    "aria-label": "Mover selecionados para \xE0 esquerda"
  }, "<"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleAllLeft,
    disabled: right.length === 0,
    "aria-label": "Mover tudo para \xE0 esquerda"
  }, "\u226A"))), /*#__PURE__*/_react["default"].createElement(_Hidden["default"], {
    mdUp: true
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    container: true,
    direction: "row",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleAllRight,
    disabled: left.length === 0,
    "aria-label": "Mover tudo para baixo"
  }, "\u21A1"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleCheckedRight,
    disabled: checkedLeft === 0,
    "aria-label": "Mover selecionados para baixo"
  }, "\u2193"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleCheckedLeft,
    disabled: checkedRight === 0,
    "aria-label": "Mover selecionados para cima"
  }, "\u2191"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "outlined",
    className: classes.button,
    onClick: handleAllLeft,
    disabled: right.length === 0,
    "aria-label": "Mover tudo para cima"
  }, "\u219F")))), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true,
    xs: 12,
    sm: 12,
    md: true,
    className: classes.rootPaperRight
  }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
    component: "legend",
    className: classes.label
  }, labelRight), customList(right, setCheckedRight, 'Nenhum item adicionado')));
};
SttDoubleList.propTypes = {
  selectedItens: _propTypes["default"].arrayOf(_propTypes["default"].object),
  allItens: _propTypes["default"].arrayOf(_propTypes["default"].object),
  getItemIdentifier: _propTypes["default"].func.isRequired,
  getItemText: _propTypes["default"].func.isRequired,
  onChange: _propTypes["default"].func,
  callbackReset: _propTypes["default"].func,
  reset: _propTypes["default"].bool,
  labelLeft: _propTypes["default"].string,
  labelRight: _propTypes["default"].string
};
SttDoubleList.defaultProps = {
  selectedItens: [],
  allItens: [],
  reset: false
};
var _default = SttDoubleList;
exports["default"] = _default;